import React from 'react';

const CancelSubscriptionTutorial: React.FC = () => {
  return (
    <div className="accordion-container" style={{ backgroundColor: '#1a1a1a', padding: '30px', borderRadius: '8px', textAlign: 'justify', margin: '20px' }}>
      <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '20px' }}>¿Cómo cancelo mi suscripción?</h2>
      <p style={{ color: '#ccc' }}>Puedes cancelar tu suscripción de TCS GO fácilmente siguiendo estos pasos según el dispositivo que utilices:</p>

      <h3 style={{ color: '#00aaff' }}>En dispositivos iOS</h3>
      <ol style={{ color: '#ccc' }}>
        <li>Abre la aplicación <strong>Configuración</strong></li>
        <li>Toca tu nombre (en la parte superior)</li>
        <li>Selecciona <strong>Suscripciones</strong></li>
        <li>Busca y selecciona <strong>TCS GO!</strong></li>
        <li>Toca <strong>Cancelar suscripción</strong></li>
        <li>Confirma tu decisión</li>
      </ol>

      <h3 style={{ color: '#00aaff' }}>En dispositivos Android</h3>
      <ol style={{ color: '#ccc' }}>
        <li>Abre <strong>Google Play Store</strong></li>
        <li>Toca tu foto de perfil (esquina superior derecha)</li>
        <li>Selecciona <strong>Pagos y Suscripciones</strong></li>
        <li>Toca <strong>Suscripciones</strong></li>
        <li>Busca y selecciona <strong>TCS GO!</strong></li>
        <li>Toca <strong>Cancelar suscripción</strong></li>
        <li>Sigue las instrucciones para confirmar</li>
      </ol>

      <h3 style={{ color: '#00aaff' }}>En nuestra web (tcsgo.com)</h3>
      <ol style={{ color: '#ccc' }}>
        <li>Inicia sesión en tu cuenta</li>
        <li>Presiona el ícono de usuario (extremo derecho de la pantalla)</li>
        <li>Selecciona <strong>Pagos</strong></li>
        <li>Haz clic en <strong>Cancelar suscripción</strong></li>
      </ol>

      <p style={{ color: '#ccc' }}>
        Si tienes problemas para cancelar a través de nuestra web, contacta a nuestro equipo de soporte proporcionando:
      </p>
      <ul style={{ color: '#ccc' }}>
        <li>Correo electrónico asociado a la suscripción</li>
        <li>Nombre completo</li>
        <li>Últimos 4 dígitos de tu tarjeta</li>
      </ul>

      <p style={{ color: '#999', fontStyle: 'italic' }}>
        Nota: Tu suscripción permanecerá activa hasta el final del periodo de facturación actual.
      </p>
    </div>
  );
};

export default CancelSubscriptionTutorial;